import { Search as SearchIcon } from "@tamagui/lucide-icons";
import { Input, YStack } from "@medbillai/ui";
import { PayerResults } from "../../onboarding-v3/PayerResults";
import { usePayerSearch } from "../../onboarding-v3/utils/usePayerSearch";
import type { Insurer } from "../root/usePlanSetup";

// Rounded down from the active payer catalog.
const SEARCHABLE_PAYERS = "3,500+";
// The sheet renders every row, so cap results.
const MAX_SEARCH_RESULTS = 30;

/** The insurer picker in Coverage's sheets. */
export function PayerSearch({
  onPick,
  onNotListed
}: {
  onPick: (insurer: Insurer) => void;
  /** A carrier the catalog doesn't have. */
  onNotListed: () => void;
}) {
  const search = usePayerSearch({
    limit: MAX_SEARCH_RESULTS
  });
  return <YStack gap="$sp1.5" flex={1} paddingTop="$sp1.5" $platform-web={{
    minHeight: 0
  }} data-sentry-element="YStack" data-sentry-component="PayerSearch" data-sentry-source-file="PayerSearch.tsx">
      <Input testID="select-insurance.search" shape="pill" aria-label={`Search ${SEARCHABLE_PAYERS} insurers`} placeholder={`Search ${SEARCHABLE_PAYERS} insurers`} leftIcon={SearchIcon} clearable value={search.searchText} onChangeText={search.setSearchText} autoCapitalize="none" autoComplete="off" autoCorrect={false} spellCheck={false} data-sentry-element="Input" data-sentry-source-file="PayerSearch.tsx" />
      <PayerResults search={search} inSheet onPick={payer => onPick({
      carrier: payer.displayName,
      payerId: payer.primaryPayerId,
      logoUrl: payer.logoUrl ?? null,
      memberIdRequired: payer.memberIdRequired
    })} onNotListed={onNotListed} data-sentry-element="PayerResults" data-sentry-source-file="PayerSearch.tsx" />
    </YStack>;
}